import {
  Component,
  OnInit,
  ViewChildren,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { MyDatePicker } from "mydatepicker";
import { IMyDpOptions, IMyDateModel } from "mydatepicker";
import { AppService } from "../services/app.service";
import { HttpParams } from "@angular/common/http";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "app-hold-or-cancel",
  templateUrl: "./hold-or-cancel.component.html",
})
export class HoldOrCancelComponent implements OnInit {
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };

  @ViewChild("showPopup") showPopup: TemplateRef<any>;
  fromDate1: any = "";
  fromDate: any = "";
  toDate: any = "";
  planList: any = "";
  isDisable = false;
  isActive = false;
  isLoad = false;
  dateDetails: FormGroup;
  dateDetails1: FormGroup;
  reasonForm: FormGroup;
  submitted = false;
  submitted1 = false;
  reasonSubmit = false;
  public myDatePickerOptions: IMyDpOptions = {};
  reason = "";
  message = "";
  errorMsg = "";
  showCancelDiv = false;

  warningMessage =
    "Warning: Your account will be put on Hold with us. Your available Time Slots will not be offered to patient to schedule and you will not be able to use SchedMed's platform.";

  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private appservice: AppService
  ) {
    const date = new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      editableDateField: false,
      showClearDateBtn: false,
      disableUntil: { year: year, month: month, day: date.getDate() },
    };
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.dateDetails = this.formBuilder.group({
      fromDate: ["", [Validators.required]],
    });
    this.dateDetails1 = this.formBuilder.group({
      fromDate1: ["", [Validators.required]],
      toDate1: ["", [Validators.required]],
    });
    this.reasonForm = this.formBuilder.group({
      reason: ["", [Validators.required]],
    });
    this.getPlanList();
  }

  viewCancelDiv() {
    this.showCancelDiv = true;
  }

  getPlanList() {
    this.appservice
      .getPlanList(localStorage.getItem("testCenterId").toString())
      .subscribe((plan) => {
        this.isLoad = true;
        if (plan["status"]["status"] === 200) {
          this.planList = plan["entity"];
          if (this.planList) {
            if (this.planList.hold_active === true) {
              this.isDisable = true;
              if (this.planList.holdType === "3") {
                const fromDate = new Date(this.planList.holdedOn);
                this.dateDetails1.patchValue({
                  fromDate1: {
                    date: {
                      year: fromDate.getFullYear(),
                      month: fromDate.getMonth() + 1,
                      day: fromDate.getDate(),
                    },
                  },
                });
              }
            } else {
              this.isDisable = false;
            }
          }
        }
        if (!this.planList) {
          this.isActive = true;
        }
      });
  }

  holdPlan(type) {
    this.submitted = false;
    this.submitted1 = false;
    this.reason = "";
    let params = new HttpParams();
    if (!this.planList) {
      params = params.append("status", "trail");
    }
    params = params.append("type", "hold");
    params = params.append("holdType", type.toString());

    if (type === "1") {
      params = params.append(
        "holdFromDate",
        moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD").toString() +
          " 00:00:00"
      );
    }

    if (type === "2") {
      this.submitted1 = true;
      if (this.dateDetails.invalid) {
        return;
      }
      this.fromDate1 = this.dateDetails.controls["fromDate"].value;
      if (this.fromDate1) {
        params = params.append(
          "holdFromDate",
          moment(this.fromDate1.jsdate, "YYYY-MM-DD")
            .format("YYYY-MM-DD")
            .toString() + " 00:00:00"
        );
      }
    }

    if (type === "3") {
      this.submitted = true;
      if (this.dateDetails1.invalid) {
        return;
      }
      this.fromDate = this.dateDetails1.controls["fromDate1"].value;
      this.toDate = this.dateDetails1.controls["toDate1"].value;
      if (this.fromDate && this.toDate) {
        const date = moment(this.fromDate.jsdate, "YYYY-MM-DD");
        const todate = moment(this.toDate.jsdate, "YYYY-MM-DD");
        const duration = todate.diff(date, "days");
        if (duration > 0) {
          params = params.append(
            "holdToDate",
            moment(this.toDate.jsdate, "YYYY-MM-DD")
              .format("YYYY-MM-DD")
              .toString() + " 00:00:00"
          );
          params = params.append(
            "holdFromDate",
            moment(this.fromDate.jsdate, "YYYY-MM-DD")
              .format("YYYY-MM-DD")
              .toString() + " 00:00:00"
          );
        } else {
          this.toastr.error("To Date Must Greater than From Date");
          return 0;
        }
      }
    }
    if (this.planList) {
      this.planChange(params);
    }
  }

  planChange(params) {
    params = params.append("id", this.planList.id);
    params = params.append("status", "");
    params = params.append("reason", this.reason ? this.reason : "");
    const params1 = params.toString();
    this.appservice.holdSubscription(params1).subscribe((plan) => {
      if (plan["status"]["status"] === 200) {
        this.refresh();
      } else if (plan["status"]["status"] === 204) {
        this.refresh();
      }
    });
  }

  refresh() {
    this.submitted = false;
    this.submitted1 = false;
    this.reasonSubmit = false;
    this.dateDetails.reset();
    this.dateDetails1.reset();
    this.reasonForm.reset();
    if (this.reason) {
      this.modalRef.hide();
      this.message = "Plan Canceled Successfully";
      this.clearMessage();
    } else {
      this.message = "Success";
      this.clearMessage();
    }
    this.fromDate = "";
    this.toDate = "";
    this.reason = "";
    this.fromDate1 = "";
    this.planList = "";
    this.dateDetails.controls["fromDate"].reset();
    this.dateDetails1.controls["fromDate1"].reset();
    this.dateDetails1.controls["toDate1"].reset();

    this.getPlanList();
  }

  onDateChanged(event: IMyDateModel) {}

  cancelAccount() {
    this.reasonSubmit = true;
    if (this.reasonForm.invalid) {
      return;
    }
    this.reason = this.reasonForm.controls["reason"].value;
    this.modalRef = this.modalService.show(
      this.showPopup,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  unHold() {
    this.warningMessage = "";
    let params = new HttpParams();
    params = params.append("id", this.planList.id);
    params = params.append("type", "activate");
    this.appservice.holdSubscription(params).subscribe(
      (plan) => {
        if (plan["status"]["status"] === 200) {
          this.message = "Your account activated Successfully";
          this.submitted = false;
          this.submitted1 = false;
          this.reasonSubmit = false;
          this.dateDetails.reset();
          this.dateDetails1.reset();
          this.reasonForm.reset();
          this.clearMessage();
          this.getPlanList();
        }
      },
      (err) => {
        this.errorMsg = err;
        this.clearMessage();
      }
    );
  }

  triggerPopup() {
    let params = new HttpParams();
    params = params.append("type", "cancel");
    params = params.append("holdType", "0");
    if (this.planList) {
      this.planChange(params);
    }
  }

  clearMessage() {
    setTimeout(() => {
      this.message = "";
      this.errorMsg = "";
    }, 5000);
  }
}
